import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { setAccountLink } from '../../../redux/actions';
import { dateService } from '../../../services/date';
import { paymentsService } from './payments-service';

import SnackBar from '../../admin/accounts/snackbar';
import Icon from '../../ui/icon';

const GO_TO_STRIPE_DASHBOARD = 'Go To Stripe Dashboard';
const SETUP_PENDING = 'Setup Pending';

const PaymentSetup = ({ stripeStatus, accountLink, match }) => {
  const [snackbarDisabled, setsnackbarDisabled] = useState(false);
  const dispatch = useDispatch();

  function getConditionalItems() {
    const checkIcon = (
      <div className="check-icon-container">
        <Icon iconName="check" size={10} />
      </div>
    );

    const alertIcon = (
      <div className="alert-icon-container">
        <Icon iconName="filledAlert" size={16} />
      </div>
    );

    return {
      pending: {
        snackbarTxt: '',
        buttonDescription: '',
        buttonTxt: SETUP_PENDING,
        icon: alertIcon,
        description:
          'We are setting up your Stripe account. This takes about 5-10 minutes to complete.',
      },
      disabled: {
        snackbarTxt: '',
        buttonDescription: 'Fix and edit your billing details directly on Stripe',
        buttonTxt: GO_TO_STRIPE_DASHBOARD,
        icon: alertIcon,
        description: getDisabledReasonError(),
      },
      'descriptive-error': {
        snackbarTxt: '',
        buttonDescription: 'Fix and edit your billing details directly on Stripe',
        buttonTxt: GO_TO_STRIPE_DASHBOARD,
        icon: alertIcon,
        description: getDescriptiveErrors(),
      },
      unconnected: {
        snackbarTxt: '',
        buttonDescription: '',
        buttonTxt: 'Connect With Stripe',
        icon: alertIcon,
        description: 'Setup your account with Stripe to submit your billing details.',
      },
      success: {
        snackbarTxt: 'Payments successfully connected with Stripe.',
        buttonDescription: 'View and manage your billing details directly on Stripe.',
        buttonTxt: GO_TO_STRIPE_DASHBOARD,
        icon: checkIcon,
        description: 'Connected to Stripe',
      },
    };
  }

  async function getAccountLink() {
    const res = await paymentsService.getAccountLink(match.params.publisherId);
    dispatch(setAccountLink(res.data.data[0]));
  }

  const { snackbarTxt, buttonDescription, icon, buttonTxt, description } = stripeStatus
    ? getConditionalItems()[stripeStatus]
    : {};

  function getDescriptiveErrors() {
    const deadline = accountLink.current_deadline ? (
      <>
        <span> by </span>
        <span className="deadline">
          {dateService.formatDisplayDate(accountLink.current_deadline)}{' '}
        </span>
      </>
    ) : (
      ' as soon as possible '
    );

    const errors = accountLink.errors
      ? accountLink.errors.map((error, index) => <li key={index}>{error}</li>)
      : null;

    const errorItems = errors ? (
      <>
        <div className="error-details">Error Details:</div>
        <ul>{errors}</ul>
      </>
    ) : null;

    return (
      <>
        <div className="descriptive-errors">
          <span>{'There was an error with your account. Please '}</span>
          <span onClick={getAccountLink}>
            <a
              className="visit-stripe-dashboard"
              href={accountLink.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              visit your Stripe dashboard
            </a>
          </span>
          <span>&nbsp;to address these errors</span>
          <span>{deadline}</span>
          <span>to prevent your account from being disabled.</span>
        </div>
        {errorItems}
        <div className="please-refresh">
          Please refresh the page to load latest account details.
        </div>
      </>
    );
  }

  function getDisabledReasonError() {
    return (
      <div className="disabled-reason-error">
        <span>
          Your account has been disabled because an error occurred with your Stripe payment setup.
        </span>
        <span>{' To reactivate your account, please '}</span>
        <span onClick={getAccountLink}>
          <a
            className="visit-stripe-dashboard"
            href={accountLink.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            visit your Stripe dashboard.
          </a>
        </span>
      </div>
    );
  }

  const arrowRight =
    buttonTxt === GO_TO_STRIPE_DASHBOARD ? <span className="arrow-right"></span> : null;

  const snackBar =
    snackbarTxt && !snackbarDisabled ? (
      <SnackBar
        message={snackbarTxt}
        setSnackbarTxt={() => setsnackbarDisabled(true)}
        timeout={4}
      />
    ) : null;

  const buttonItem = (
    <button className="connect-btn">
      {buttonTxt}
      {arrowRight}
    </button>
  );

  const accountLinkBtn =
    buttonTxt === SETUP_PENDING ? (
      buttonItem
    ) : accountLink.url ? (
      <span onClick={getAccountLink}>
        <a href={accountLink.url} target="_blank" rel="noopener noreferrer">
          {buttonItem}
        </a>
      </span>
    ) : null;

  return (
    <div className={`super-section ${stripeStatus}`}>
      <div className="section payment-setup">
        <div className="payment-setup-instructions">
          <h3 className="small-header">
            <span>Setup Narrativ Payments with</span>
            <Icon iconName="stripeLogo" size={52} />
          </h3>
          <div className="description">
            {icon}
            <span>{description}</span>
          </div>
        </div>
        <div className="button-items">
          {accountLinkBtn}
          <div className="btn-description">{buttonDescription}</div>
        </div>
      </div>
      <hr id="super-section-hr"></hr>
      {snackBar}
    </div>
  );
};

export default PaymentSetup;
